<template>
    <ul class="profile-experiences__list">
        <li
            v-for="experience in experiencesSectionState"
            :id="anchorsPageProfile.experienceById(experience.id!)"
            :key="`experience--${experience.id}`"
            :value="experience.index"
            :data-testid="`profile-experience-item--${experience.index}`"
            class="profile-experiences__list-item"
        >
            <div class="profile-experiences__list-item-wrapper">
                <ExperienceReadOnly
                    :data-testid="`experience-read-only-item--${experience.index}`"
                    :experience="mapToExperienceItem(experience)"
                ></ExperienceReadOnly>
            </div>
        </li>
    </ul>
</template>

<script setup lang="ts">
    import {useFeatureFlag} from '@malt/feature-flags';
    import type {ExperienceItem} from '~/components/_common/experience/ExperienceItem';
    import ExperienceReadOnly from '~/components/_common/experience/ExperienceReadOnly.vue';
    import {anchorsPageProfile} from '~/config/anchors';
    import type {ExperienceRequest} from '~/types/infra/ExperienceRequest';
    import {useExperienceSectionState} from '../../composable/useExperienceSectionState';

    // State
    const experiencesSectionState = useExperienceSectionState();
    const isNewCompanyLogoEnabled = useFeatureFlag('new-company-logo');

    function mapToExperienceItem(xpRequest: ExperienceRequest): ExperienceItem {
        return {
            company: xpRequest.company,
            title: xpRequest.title,
            activityArea: xpRequest.area,
            location: xpRequest.location?.formattedAddress,
            startDate: xpRequest.startDate,
            endDate: xpRequest.endDate,
            currentJob: xpRequest.currentJob,
            description: xpRequest.description,
            skills: xpRequest.skills.map((skill) => skill.label),
            logoSrc: xpRequest.logo?.baseUrl
                ? `${xpRequest.logo.baseUrl}/${xpRequest.logo.name}`
                : isNewCompanyLogoEnabled.value
                  ? (xpRequest.logoUrl ?? undefined)
                  : undefined,
            missionId: xpRequest.missionId,
        };
    }
</script>
